/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Container } from '@bottlebooks/gatsby-theme-base';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import { resolve } from '../../helpers/path';
import SiteSearch from './SiteSearch';

export default function SiteSearchSection({
  locale,
  paths,
  segments,
  //   ...rest
}) {
  const { i18n } = useLingui();

  return (
    <Container>
      <Box
        sx={{
          transform: 'translateY(-50%)',
          position: 'relative',
          zIndex: 'modal',
        }}
      >
        <SiteSearch
          variant="largest"
          locale={locale}
          sx={{ boxShadow: 'overlay', backgroundColor: 'white' }}
          placeholder={i18n._(t`Search for producer, wine or region…`)}
          paths={paths}
          getExhibitorLink={({ slug }) => resolve([paths.exhibitors, slug])}
          getProductLink={({ slug, exhibitor }) =>
            resolve([
              paths.exhibitors,
              exhibitor?.slug,
              segments?.product || paths?.product,
              slug,
            ])
          }
        />
      </Box>
    </Container>
  );
}
